import { render, staticRenderFns } from "./ArticleDialogEditRow.vue?vue&type=template&id=1ef877dc&scoped=true"
import script from "./ArticleDialogEditRow.vue?vue&type=script&lang=js"
export * from "./ArticleDialogEditRow.vue?vue&type=script&lang=js"
import style0 from "./ArticleDialogEditRow.vue?vue&type=style&index=0&id=1ef877dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef877dc",
  null
  
)

export default component.exports